import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { AuthServiceConfig, SocialLoginModule as NativeSocialLoginModule } from 'angularx-social-login';

import { SocialLoginFactory } from './factory/social-login.factory';
import { SocialLoginService } from './services/social-login.service';
import { SocialLoginComponent } from './components/social-login.component';

@NgModule({
    imports: [
        CommonModule,

        NativeSocialLoginModule,
    ],
    declarations: [
        SocialLoginComponent,
    ],
    providers: [
        SocialLoginService,
    ],
    exports: [
        SocialLoginComponent,
    ],
})

export class SocialLoginModule {
    public static forRoot(environment): ModuleWithProviders {
        return {
            ngModule: SocialLoginModule,
            providers: [
                {
                    provide: AuthServiceConfig,
                    useFactory: SocialLoginFactory(environment),
                },
                {
                    provide: 'Socials',
                    useValue: environment.socialAuth,
                },
            ],
        };
    }
}
